export const BannerConfigurationMaxLength = {
  message: 500,
};

export interface BannerConfigurationFormValues {
  bannerStartDate: Date | null;
  maintenanceStartDate: Date | null;
  maintenanceEndDate: Date | null;
  message: string;
}
